import React from 'react';

import { Card, CardContent, Label } from '@shared/ui';

import { TFundAwardFormProps, fundAward } from '../../model';

import { CheckTseMarket } from './CheckTseMarket';
import { ClubCheck } from './ClubCheck';
import { FundAwardForm } from './Form';

export const Desktop = ({
  form,
  onSubmit,
  isLoading,
  customerInfo,
  open,
  setOpen,
  data,
}: TFundAwardFormProps) => {
  const componentMap = {
    tseMarket: <CheckTseMarket />,
    club: <ClubCheck />,
    form: (
      <div>
        <FundAwardForm
          form={form}
          onSubmit={onSubmit}
          isLoading={isLoading}
          open={open}
          setOpen={setOpen}
          data={data}
        />
      </div>
    ),
  };

  const getComponentKey = (): keyof typeof componentMap => {
    if (!customerInfo?.isInTseMarket) return 'tseMarket';
    if (!customerInfo?.clubTotalRial) return 'club';
    return 'form';
  };

  return (
    <div className='layout w-full flex flex-col gap-5 pt-[24px]  '>
      <Label className='h5-bold'>{fundAward.title}</Label>
      <Card className='w-full p-6'>
        <CardContent className='flex flex-col items-center justify-center gap-5 min-h-[333px] w-full'>
          {componentMap[getComponentKey()]}
        </CardContent>
      </Card>
    </div>
  );
};
